// Single source of truth for the product name.
//
// The name is settled: Margin Lens (11 Aug 2026). It replaced "NettBack", which
// was rejected at ASIC, and "Margin Desk" before that, which was dropped because
// margindesk.com redirects to margindesk.ai (a US B2B RevOps SaaS). Every
// client-facing string that names the product imports from here — that is what
// made this rename one edit plus a mechanical sweep rather than a hunt.
//
// The wordmark is two words, both capitalised: "Margin Lens". Not MarginLens,
// not marginlens, except in identifiers and filenames where a slug is required.
export const BRAND = "Margin Lens";

// The domain a client-facing address may use. Registered 11 Aug 2026.
export const BRAND_DOMAIN = "marginlens.com.au";

// Owned as of 11 Aug 2026.
//
// NOTE, because the brief used to imply otherwise: this constant is DOCUMENTARY.
// Nothing imports it. The real send gate is four environment variables read by
// backend/mailer.py — MAIL_ENABLED, BRAND_DOMAIN_REGISTERED, MAIL_FROM and
// SMTP_HOST — and all four must be set before anything leaves the building.
// Owning the domain does not switch mail on, and flipping this flag does not
// either. Publish SPF/DKIM first.
export const BRAND_DOMAIN_PLACEHOLDER = false;

// Trading entity. ABN registered 9 Aug 2026: sole trader, not a company.
// Checksum-verified against the ATO weighting algorithm before being written in.
// The footer and every legal page must render this from here, never inline it.
export const ABN = "21 129 630 980";

// The ASIC business name "Margin Lens" was GRANTED on 11 Aug 2026 against the
// ABN above. Documents may now describe the operator as trading as Margin Lens.
// The party lines in legal/terms-of-service.md and legal/services-agreement.md
// were updated at the same time; they remain DRAFT pending practitioner review.
export const BUSINESS_NAME_REGISTERED = true;


// ---------------------------------------------------------------------------
// LAUNCH PRICING — the Margin Audit's founding-client rate, as an explicit rule.
//
// The pricing page shows A$2,500 struck through as the standard price with A$990
// as the launch rate. Under Australian Consumer Law that strikethrough is only
// truthful while A$2,500 is a price genuinely intended to be charged once the
// launch ends — labelled "Standard price", never "was", with no countdown and
// no spot counter (see docs/GO-LIVE.md §10b and Schedule 1A of the services
// agreement, which records both figures as the evidence the A$2,500 is real).
//
// Until now that rule lived only as two hardcoded strings in PricingMatrix, so
// ending the launch meant remembering to edit JSX. It is now one switch:
//
//   LAUNCH_PRICING_ACTIVE = true   -> A$2,500 struck, A$990 charged (current)
//   LAUNCH_PRICING_ACTIVE = false  -> A$2,500 shown plainly, no strikethrough
//
// THE END CONDITION IS AN OPERATOR DECISION AND IS DELIBERATELY NOT ENCODED
// HERE. A date or founding-client cap is a commercial choice; inventing one in
// code would be the same class of made-up policy the rest of this release
// refused to invent. When the operator decides the launch is over, flip this
// one flag. Until then the presentation stays as documented and truthful.
export const LAUNCH_PRICING_ACTIVE = true;
export const AUDIT_STANDARD_PRICE = "A$2,500";
export const AUDIT_LAUNCH_PRICE = "A$990";
